/**
 * IDs of all modals used in the project
 */
const ModalID = {
  login: "login-modal",
  register: "register-modal",
  createToken: "create-token-modal",
  embedToken: "embed-token-modal",
  forgotPassword: "forgot-password-modal",
  resetPassword: "reset-password-modal",
  verifyEmail: "email-verification-modal",
  ownershipTransfer: "ownership-transfer-modal"
};

export default ModalID;
